import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

function WeeklyDespositPromo(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const isPK = brandId && (brandId == 35 || brandId == 36 || brandId == 37 || brandId == 49);
    const totalCashbackAmount = (brandId == 61) ? "$100" : isPK ? "PKR 30,000" : "₹10,000";
    const isTimeZOne = (brandId == 61) ? "12:00 PM" : "12:00 PM IST"

    function getDomain(brandId: any) {
        if ([31, 32, 61, 35, 36].includes(brandId)) return "Yolo247";
        if ([37, 39, 40].includes(brandId)) return "Fomo7";
        if ([46, 47, 49].includes(brandId)) return "Fun88";
        return "Iw247";
    }
    const domainName = getDomain(brandId);

    return (
        <>
            <InformationWrapper>
                <KeyDetailsSec>
                    <MainTitle>Deposit during the week</MainTitle>
                    <p className='top-para'>And get rewarded with free spins on <strong>'AVIATOR'</strong> Spribe game. <br />The more you deposit, the more spins you unlock.</p>
                </KeyDetailsSec>
                
                <KeyDetailsSec>
                    <MainTitle>How to Claim Your Free Spins</MainTitle>
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.WeeklyDespositIconOne}`}
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Make total deposits <br /> of {totalCashbackAmount} or more during the <br />week (Sunday to Saturday).</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.WeeklyDespositIconTwo}`}
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Receive your 'Aviator' Spribe Game Free Spins automatically on Monday by {isTimeZOne}.</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.WeeklyDespositIconThree}`}
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>The higher your total weekly deposits, the more Free Spins you get!</p>
                        </KeyDetailsSecBox>
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>

                <KeyDetailsSec>
                    <MainTitle>Weekly Deposit Slabs & Free Spin Rewards</MainTitle>
                    <ImageGrid>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.WeeklyDepositSlabs}`}
                            alt="Weekly Deposit Slabs"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                            className="cashBackIconImg"
                        />
                    </ImageGrid>
                </KeyDetailsSec>

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    <ul>
                        <li><span>✦</span> <div>Weekly deposits are calculated from <strong>Sunday to Saturday</strong>.</div></li>
                        <li><span>✦</span> <div>Free Spins are credited automatically on <strong>Monday by {isTimeZOne}</strong>.</div></li>
                        <li><span>✦</span> <div>Free Spins are only applicable on 'Aviator' Spribe game.</div></li>
                        <li><span>✦</span> <div>Players can claim Free Spins only once per week, based on the highest eligible deposit slab.</div></li>
                        <li><span>✦</span> <div>Maximum winnings from free spin are capped at 1x of bet amount.</div></li>
                        <li><span>✦</span> <div>Eligible games or mechanics may change without prior notice.</div></li>
                        <li><span>✦</span> <div>{domainName} reserves the right to modify, suspend, or cancel the promotion without prior notice.</div></li>
                        <li><span>✦</span> <div>General Casino Terms & Conditions apply.</div></li>

                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(WeeklyDespositPromo));

const InformationWrapper = styled.div`
    width: 98%;
    padding: 4rem 0;
    height: auto;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.WeeklyDespositInnerBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    gap: 3rem;

    & .top-para {
        width: 100%;
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-transform: uppercase;
        margin: 0;
    }

    strong {
        color: #ffffff;
        font-family: 'Inter-Bold';
    }
`;

const MainTitle = styled.h4`
    color: #FFDE00;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
    margin: 0;
`;

const ImageGrid = styled.div`
    width: 652px;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    img {
        width: 100%;
        max-width: 100%;
    }
`;

const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    width: 70%;
    height: auto;
    gap: 2rem;
`;

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
`;

const KeyDetailsSecBox = styled.div`
    width: 28%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    padding: 2rem 1.5rem;
    gap: 10px;
    border-radius: 14px;
    border: 0.5px solid rgb(254 222 31 / 13%);
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(12.5px);

    .lazy-load-image-background {
        text-align: center;
        width: 61px;
        /* height: 61px; */
    }

    img {
        width: 100%;
    }

    & p {
        color: #FFF;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`;

const TermsAndCondition = styled.div`
    width: 620px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    border-radius: 14px;
    
    gap: 2rem;
    
    
    ul {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin: 0;
        list-style: none;
        padding: 2rem;
        border-radius: 7px;
        background: rgba(255, 255, 255, 0.17);

        li {
            color: #FFF;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            text-align: justify;
            text-transform: capitalize;
            display: flex;
            align-items: flex-start;
            gap: 10px;
            text-align: left;

            & strong {
                font-weight: 900;
            }
        }
    }
`;